export { ExclamationOctagon as default } from './ExclamationOctagon';
